//#region src/gateway.ts
var Gateway = /* @__PURE__ */ function(Gateway) {
	Gateway[Gateway["None"] = 0] = "None";
	Gateway[Gateway["CreditCall"] = 1] = "CreditCall";
	Gateway[Gateway["Square"] = 2] = "Square";
	Gateway[Gateway["CardConnect"] = 3] = "CardConnect";
	Gateway[Gateway["TCC"] = 4] = "TCC";
	Gateway[Gateway["Worldpay"] = 5] = "Worldpay";
	Gateway[Gateway["LevelUp"] = 6] = "LevelUp";
	Gateway[Gateway["Givex"] = 7] = "Givex";
	Gateway[Gateway["Heartland"] = 8] = "Heartland";
	Gateway[Gateway["AtriumStoredValue"] = 9] = "AtriumStoredValue";
	Gateway[Gateway["Archer"] = 10] = "Archer";
	Gateway[Gateway["Stripe"] = 11] = "Stripe";
	Gateway[Gateway["FreedomPayFlash"] = 12] = "FreedomPayFlash";
	Gateway[Gateway["FreedomPayKiosk"] = 13] = "FreedomPayKiosk";
	Gateway[Gateway["PinataStoredValue"] = 14] = "PinataStoredValue";
	Gateway[Gateway["Valutec"] = 15] = "Valutec";
	Gateway[Gateway["PaytronixGift"] = 16] = "PaytronixGift";
	Gateway[Gateway["OLOGift"] = 17] = "OLOGift";
	Gateway[Gateway["Elavon"] = 20] = "Elavon";
	Gateway[Gateway["VerifonePointCloud"] = 21] = "VerifonePointCloud";
	Gateway[Gateway["OloPayKioskOrderingApi"] = 22] = "OloPayKioskOrderingApi";
	Gateway[Gateway["StripeTerminal"] = 23] = "StripeTerminal";
	Gateway[Gateway["Eigen"] = 24] = "Eigen";
	Gateway[Gateway["Adyen"] = 25] = "Adyen";
	Gateway[Gateway["VerifonePointSca"] = 26] = "VerifonePointSca";
	Gateway[Gateway["EigenStoredValue"] = 27] = "EigenStoredValue";
	Gateway[Gateway["ChoptLoyalty"] = 28] = "ChoptLoyalty";
	Gateway[Gateway["PinataPay"] = 29] = "PinataPay";
	Gateway[Gateway["Como"] = 30] = "Como";
	Gateway[Gateway["PinataPayNative"] = 31] = "PinataPayNative";
	Gateway[Gateway["CbordStoredValue"] = 32] = "CbordStoredValue";
	Gateway[Gateway["OloPayKioskPaymentApi"] = 33] = "OloPayKioskPaymentApi";
	Gateway[Gateway["Thanx"] = 34] = "Thanx";
	Gateway[Gateway["Punchh"] = 35] = "Punchh";
	Gateway[Gateway["PinataLoyalty"] = 36] = "PinataLoyalty";
	Gateway[Gateway["ParPay"] = 37] = "ParPay";
	Gateway[Gateway["Chase"] = 38] = "Chase";
	Gateway[Gateway["SmoothCommerce"] = 39] = "SmoothCommerce";
	Gateway[Gateway["Spendgo"] = 40] = "Spendgo";
	Gateway[Gateway["Moneris"] = 41] = "Moneris";
	Gateway[Gateway["Starbucks"] = 42] = "Starbucks";
	Gateway[Gateway["AtriumLoyalty"] = 43] = "AtriumLoyalty";
	Gateway[Gateway["Glory"] = 44] = "Glory";
	Gateway[Gateway["PinataCashMachine"] = 45] = "PinataCashMachine";
	Gateway[Gateway["LovesRewards"] = 46] = "LovesRewards";
	Gateway[Gateway["PinataCampusCard"] = 47] = "PinataCampusCard";
	Gateway[Gateway["QuickchargeCampusCard"] = 48] = "QuickchargeCampusCard";
	Gateway[Gateway["StarbucksStoredValue"] = 49] = "StarbucksStoredValue";
	Gateway[Gateway["FreedomPayStoredValue"] = 50] = "FreedomPayStoredValue";
	Gateway[Gateway["Appfront"] = 51] = "Appfront";
	Gateway[Gateway["TransactCampusCard"] = 52] = "TransactCampusCard";
	Gateway[Gateway["GivexLoyalty"] = 53] = "GivexLoyalty";
	return Gateway;
}(Gateway || {});
//#endregion
export { Gateway };

//# sourceMappingURL=gateway.js.map